import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { instanceToModule, returnsPromise, unsupported } from './connect/Util';
let Contexts = (_class = class Contexts {
  constructor(config) {
    _defineProperty(this, "config", void 0);
    this.config = config;
  }
  getMostRecentContext() {
    return Promise.reject();
  }
  getContextInstallationForInstalledAddonContext(_options) {
    return Promise.reject();
  }
  getContextInstallationsForInstalledAddon(_options) {
    return Promise.reject();
  }
  getContext(_options) {
    return Promise.reject();
  }
  getContexts(_options) {
    return Promise.reject();
  }
}, _applyDecoratedDescriptor(_class.prototype, "getMostRecentContext", [returnsPromise, unsupported], Object.getOwnPropertyDescriptor(_class.prototype, "getMostRecentContext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getContextInstallationForInstalledAddonContext", [returnsPromise, unsupported], Object.getOwnPropertyDescriptor(_class.prototype, "getContextInstallationForInstalledAddonContext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getContextInstallationsForInstalledAddon", [returnsPromise, unsupported], Object.getOwnPropertyDescriptor(_class.prototype, "getContextInstallationsForInstalledAddon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getContext", [returnsPromise, unsupported], Object.getOwnPropertyDescriptor(_class.prototype, "getContext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getContexts", [returnsPromise, unsupported], Object.getOwnPropertyDescriptor(_class.prototype, "getContexts"), _class.prototype), _class);
export default config => instanceToModule(new Contexts(config));